import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/config";

export const useQuarterlyPerformance = ({ year } = {}) => {
  return useQuery({
    queryKey: ["quarterly-performance", year],
    queryFn: async () => {
      const params = {};

      if (year) {
        params.year = year;
      }

      const data = await api.get("get-quarterly-performance", { params });
      return data.data.data;
    },
    enabled: !!year, // Only run query when year is provided
  });
};
